import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClassNames from 'classnames';
import swal from 'sweetalert2';
import request from 'common/request';
import ReportIssuePopup from 'common/ReportIssuePopup';

import { selfAssessmentCheckIfDone, technicalCheckIfDone } from './actions';

class Navbar extends React.Component {
  componentWillMount() {
    this.props.selfAssessmentCheckIfDone();
    this.props.technicalCheckIfDone();
  }

  onClickLink(e, disabled) {
    e.preventDefault();
    if (disabled) {
      swal({
        type: 'error',
        text: 'This assessment is not avaiable.',
      });
    }
  }

  // Lightweight step-away. Does NOT change assessment state: proctoring and the
  // Competas timer (wall-clock) keep running, no sitting consumed. Warn, then use
  // the existing /logout.
  handleLogout(e) {
    e.preventDefault();
    swal({
      type: 'warning',
      title: 'Log out for a short break?',
      text:
        'Logging out does NOT pause your assessment. Your timer and proctoring ' +
        "keep running while you're away, so only log out for a quick break. If " +
        'you need to stop for a while, choose End session instead.',
      showCancelButton: true,
      confirmButtonText: 'Log out',
      cancelButtonText: 'Stay',
    }).then((result) => {
      if (result.value) {
        window.location = '/logout';
      }
    });
  }

  // Deliberate stop-and-resume-later. Runs the existing pause (banks remaining
  // time, status='paused', re-locks the gate, closes the session); the sitting
  // count advances on the next "Begin next session" resume from the dashboard.
  handleEndSession(e) {
    e.preventDefault();
    swal({
      type: 'warning',
      title: 'End this session?',
      text:
        'Ending your session banks your remaining time and uses one of your 3 ' +
        "sittings. You'll resume later from your dashboard with a new proctored " +
        'session.',
      showCancelButton: true,
      confirmButtonText: 'End session',
      cancelButtonText: 'Stay',
    }).then((result) => {
      if (!result.value) return;
      request
        .post('/technical-assessment/pause')
        .then(() => {
          window.location = '/logout';
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  setActivePage() {
    this.initializeTabs();
    const {
      // selfDone,
      technicalDone,
    } = this.props;
    this.tabs[this.props.activeTab] = true;

    // if (this.tabs.help) {
    //   this.elementHelp = <a className='nav-item is-tab is-active' href='mailto:suppor@competas.com'>Help</a>;
    // } else {
    //   this.elementHelp = <a className='nav-item is-tab' href='mailto:suppor@competas.com'>Help</a>;
    // }

    if (this.props.currentPage === 'login') {
      this.elementMobileTechnical = null;
      this.elementTabletTechnical = null;
      // this.elementMobileResultsDashboard = null;
      // this.elementTabletResultsDashboard = null;
      // this.elementMobileSelfProfile = null;
      // this.elementTabletSelfProfile = null;
      if (this.tabs.login) {
        this.elementLogInOut = (
          <a className="nav-item is-tab is-active" href="/login">
            Login
          </a>
        );
      } else {
        this.elementLogInOut = (
          <a className="nav-item is-tab" href="/login">
            Login
          </a>
        );
      }
    } else {
      // TECHNICAL ASSESSMENT
      const technicalClassesMobile = ClassNames({
        'nav-item': true,
        'is-tab': true,
        'is-hidden-mobile': true,
        'is-active': this.tabs.technicalAssessment,
        'is-disabled': technicalDone,
      });

      const technicalClassesTablet = ClassNames({
        'nav-item': true,
        'is-tab': true,
        'is-hidden-tablet': true,
        'is-active': this.tabs.technicalAssessment,
        'is-disabled': technicalDone,
      });

      this.elementMobileTechnical = (
        <a
          className={technicalClassesMobile}
          href="/technical-assessment"
          onClick={(e) => {
            this.onClickLink(e, technicalDone);
          }}
        >
          Technical assessment
        </a>
      );
      this.elementTabletTechnical = (
        <a
          className={technicalClassesTablet}
          href="/technical-assessment"
          onClick={(e) => {
            this.onClickLink(e, technicalDone);
          }}
        >
          Technical assessment
        </a>
      );

      // RESULTS DASHBOARD
      // const resultsDashboardClassesMobile = ClassNames({
      //   'nav-item': true,
      //   'is-tab': true,
      //   'is-hidden-mobile': true,
      //   'is-active': this.tabs.resultsDashboard,
      //   'is-disabled': !selfDone
      // });

      // const resultsDashboardClassesTablet = ClassNames({
      //   'nav-item': true,
      //   'is-tab': true,
      //   'is-hidden-tablet': true,
      //   'is-active': this.tabs.resultsDashboard,
      //   'is-disabled': !selfDone
      // });

      // this.elementMobileResultsDashboard = <a className={resultsDashboardClassesMobile} href='/results-dashboard'>Results dashboard</a>;
      // this.elementTabletResultsDashboard = <a className={resultsDashboardClassesTablet} href='/results-dashboard'>Results dashboard</a>;

      // if (this.tabs.selfProfile) {
      //   this.elementMobileSelfProfile = <a className='nav-item is-tab is-hidden-mobile is-active' href='/self-profile'>Self-profile</a>;
      //   this.elementTabletSelfProfile = <a className='nav-item is-tab is-hidden-tablet is-active' href='/self-profile'>Self-profile</a>;
      // } else {
      //   this.elementMobileSelfProfile = <a className='nav-item is-tab is-hidden-mobile' href='/self-profile'>Self-profile</a>;
      //   this.elementTabletSelfProfile = <a className='nav-item is-tab is-hidden-tablet' href='/self-profile'>Self-profile</a>;
      // }

      if (this.props.currentPage === 'technicalAssessment') {
        // Two-button exit for a candidate in an active sitting.
        this.elementLogInOut = (
          <span className="nav-item">
            <a
              className="nav-item is-tab"
              href="/logout"
              onClick={(e) => this.handleLogout(e)}
            >
              Log out
            </a>
            <a
              className="nav-item is-tab"
              href="/logout"
              onClick={(e) => this.handleEndSession(e)}
            >
              End session
            </a>
          </span>
        );
      } else if (this.tabs.logout) {
        this.elementLogInOut = (
          <a className="nav-item is-tab is-active" href="/logout">
            Logout
          </a>
        );
      } else {
        this.elementLogInOut = (
          <a className="nav-item is-tab" href="/logout">
            Logout
          </a>
        );
      }
    }
  }

  initializeTabs() {
    this.tabs = {
      technicalAssessment: false,
      // resultsDashboard: false,
      // selfProfile: false,
      help: false,
      login: false,
      logout: false,
    };
  }

  render() {
    this.setActivePage();

    return (
      <nav className="nav has-shadow">
        <div className="container main-header">
          <div className="nav-left">
            <a className="nav-item">
              <img
                className="md-logo"
                src="/assets/img/logoDarkBgWhiteFont.png"
                alt="logo"
              />
            </a>
            {this.elementMobileTechnical}
            {/* {this.elementMobileResultsDashboard} */}
            {/* {this.elementMobileSelfProfile} */}
          </div>
          <span id="nav-toggle" className="nav-toggle">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <div id="nav-menu" className="nav-right nav-menu">
            {this.elementTabletTechnical}
            {/* {this.elementTabletResultsDashboard} */}
            {/* {this.elementTabletSelfProfile} */}
            <ReportIssuePopup />
            {/* {this.elementHelp} */}
            {this.elementLogInOut}
          </div>
        </div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  currentPage: PropTypes.string,
  activeTab: PropTypes.string,
  technicalDone: PropTypes.bool,
  selfAssessmentCheckIfDone: PropTypes.func,
  technicalCheckIfDone: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { navbar } = state;
  const { currentPage, activeTab, selfDone, technicalDone } = navbar;
  return {
    currentPage: currentPage,
    activeTab: activeTab,
    selfDone: selfDone,
    technicalDone: technicalDone,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selfAssessmentCheckIfDone: () => {
      dispatch(selfAssessmentCheckIfDone());
    },
    technicalCheckIfDone: () => {
      dispatch(technicalCheckIfDone());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.jsx